import React, { SyntheticEvent } from "react";
import { useForm } from "react-hook-form";
import Modal from "@mui/material/Modal";
import { Box, Divider, FormControl, IconButton, Typography } from "@mui/material";
import Grid from "@mui/system/Grid";

import {
  ButtonCloseStyle,
  ButtonResendStyle,
  ButtonVerifyStyle,
  FaXmarkIcon,
  HorizontalDivider,
  InputStyle,
  MfaModalBox,
  ModalGrid,
} from "../styles/styles";
import { FormInputText } from "../../components/FormInputText";
import { flexAllCentre, flexAllEnd } from "../../styles/mui/styles/display";
import { rules } from "../../utils/validation/Validation";
import { ButtonContained } from "./button";

interface MFAProps  {
  sendMfaOnClick: (mfaOtpValue: string) => void;
  resendMfaOnClick: () => void;
  closeMfaOnClick: () => void;
  handleModalClose: (event: SyntheticEvent, reason: string) => void;
  isSendButtonDisabled: false;
  isResendButtonDisabled: false;
  isCloseButtonDisabled: false;
  openModal: boolean;
  userSendMfaInfoState: any
}

const MFA: React.FC<MFAProps> = ({
  sendMfaOnClick,
  resendMfaOnClick,
  isSendButtonDisabled,
  isResendButtonDisabled,
  handleModalClose,
  closeMfaOnClick,
}) => {
  const methods = useForm<any>({
    defaultValues: "",
  });

  const { handleSubmit, control } = methods;

  const onSubmit = (mfaOtpValue: string) => {
    sendMfaOnClick(mfaOtpValue);
  };

  const handleVerify = () => {
    handleSubmit(onSubmit)();
  };



  return (
    <Modal
      open={true}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={flexAllCentre}
    >
      <Box sx={MfaModalBox}>
        <Grid container mb="0.4rem">
          <Grid size={{ xs: 11.5 }}>
            <Typography id="modal-modal-title" variant="h1">
              Enter MFA Code
            </Typography>
          </Grid>
          <Grid size={{ xs: 0.5 }}>
            <IconButton onClick={closeMfaOnClick}>
              <FaXmarkIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Divider sx={HorizontalDivider} />
        <Box sx={ModalGrid}>
          <Typography id="modal-modal-title" variant="h4" component="h2">
            Enter Code Sent on Your Email / Phone no.
          </Typography>
        </Box>
        <Box mb="2rem">
          <FormControl variant="standard">
            <FormInputText
              name="mfaOtpCodeInput"
              control={control}
              style={InputStyle}
              helper={rules.mfaCode}
            />
          </FormControl>
        </Box>
        <Divider sx={HorizontalDivider} />
        <Grid container sx={ModalGrid}>
          <Grid size={{ xs: 12 }} sx={flexAllEnd}>
            <ButtonContained
              id="btnVerify"
              onClick={handleVerify}
              label="Submit"
              disabled={isSendButtonDisabled}
              style={ButtonVerifyStyle}
            />
            <ButtonContained
              id="btnResend"
              onClick={resendMfaOnClick}
              label="Resend"
              disabled={isResendButtonDisabled}
              style={ButtonResendStyle}
            />
            <ButtonContained
              id="btnClose"
              onClick={closeMfaOnClick}
              label="Close"
              disabled={isResendButtonDisabled}
              style={ButtonCloseStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MFA;
